import styled from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../foundation/spacing/utils.js';
import { containerBreakpoints } from '../../foundation/breakpoints/values.js';
import { Link } from '../Link/Link.js';

var BREADCRUMB_MARGIN = themeGet('spacing.xl');
var Container = styled.nav.withConfig({
  displayName: "Container",
  componentId: "sc-10b3n2z-0"
})(["display:flex;justify-content:flex-start;align-items:center;container-type:inline-size;width:100%;overflow:hidden;white-space:nowrap;"]);
/* truncate in a separate element, because if you truncate in ItemContainer the "/"-separator will be hidden */
var Truncate = styled.div.withConfig({
  displayName: "Truncate",
  componentId: "sc-10b3n2z-1"
})(["display:flex;align-items:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:", ";", "{max-width:", ";}"], pxToRem(100), containerBreakpoints.sm, pxToRem(200));
var ItemContainer = styled.div.withConfig({
  displayName: "ItemContainer",
  componentId: "sc-10b3n2z-2"
})(["position:relative;display:flex;justify-content:flex-start;align-items:stretch;flex:0 100 auto;transition:flex 0.1s ease-in-out;min-width:", ";margin-right:", ";color:", ";font-size:", ";&:first-child,&:last-child,&:nth-last-child(2){flex-shrink:0.5;}&:not(:last-child)::after{content:'/';width:", ";text-align:center;position:absolute;right:calc(-1 * ", ");}"], pxToRem(10), BREADCRUMB_MARGIN, themeGet('color.100'), themeGet('fontSize.medium'), BREADCRUMB_MARGIN, BREADCRUMB_MARGIN);
var StyledLink = styled(Link).attrs(function () {
  return {
    appearance: 'text-200'
  };
}).withConfig({
  displayName: "StyledLink",
  componentId: "sc-10b3n2z-3"
})(["color:", ";cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;", ":last-child &{cursor:default;background-image:none;color:", ";margin-right:0;}&:hover{color:", ";}"], themeGet('color.100'), ItemContainer, themeGet('color.200'), themeGet('color.100'));

export { BREADCRUMB_MARGIN, Container, ItemContainer, StyledLink, Truncate };
